import { normalize } from "common/lib/normalize";
import { getSortObj } from "common/lib/tableDataOptions";
import { getPayments } from "common/services/payments.service";
import moment from "moment";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";

const Payments = () => {
  const { id: individualId } = useParams();

  const [data, setData] = useState<any>([]);
  console.log("Data", data);
  const [, setLoading] = useState(false);

  const [sorted, setSorted] = useState([{ id: "createdAt", desc: true }]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sortObj = getSortObj(sorted);

        setLoading(true);
        const response = await getPayments({
          populate: ["mda", "positionType", "paymentCategory", "mda.region", "agency"],
          filters: {
            individual: individualId,
          },
          sort: sortObj,
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [individualId, sorted]);

  return (
    <Col xxl={12}>
      <Card className="mt-5 mt-xxl-4">
        <CardHeader className="align-items-center d-flex">
          {/* <h4 className="card-title mb-0 flex-grow-1">
        Contracts / Payments
      </h4> */}
          <h6 className="mb-0 fw-semibold text-uppercase flex-grow-1">
            Contracts / Payments
          </h6>
          <div className="flex-shrink-0">
            <UncontrolledDropdown className="card-header-dropdown">
              <DropdownToggle tag="a" className="text-reset" role="button">
                <span className="fw-semibold text-uppercase fs-12">
                  Sort by:{" "}
                </span>
                <span className="text-muted">
                  Date<i className="mdi mdi-chevron-down ms-1"></i>
                </span>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-end">
                <DropdownItem
                  onClick={() => {
                    setSorted([{ id: "createdAt", desc: true }]);
                  }}
                >
                  Date
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setSorted([{ id: "mda.name", desc: true }]);
                  }}
                >
                  MDA
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setSorted([{ id: "amountPerMonth", desc: true }]);
                  }}
                >
                  Amount
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        </CardHeader>

        <CardBody>
          <div className="table-responsive table-card">
            <table className="table table-hover table-centered align-middle table-nowrap mb-0 table-striped">
              <tbody>
                {(data || []).map((item: any, key: any) => (
                  <tr key={key}>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="avatar-sm rounded p-1 me-2">
                          <div className="avatar-title bg-primary-subtle text-danger rounded fs-24">
                            <i className="ri-bank-line text-primary"></i>
                          </div>
                        </div>
                        <div>
                          <h5 className="fs-14 my-1">
                            <Link
                              to={`/payments/${item?.id}`}
                              className="text-body"
                            >
                              {item?.mda?.name || ""}
                            </Link>
                          </h5>
                          <span className="text-muted">
                            {item?.mda?.region?.name || ""}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <h5 className="fs-14 my-1 fw-normal">
                        {item?.positionTitle || ""}
                      </h5>
                      <span className="text-muted">Position Title</span>
                    </td>
                    <td>
                      <h5 className="fs-14 my-1 fw-normal">
                        {(item?.amountPerMonth && `$ ${item?.amountPerMonth}`) ||
                          "Not Provided"}
                      </h5>
                      <span className="text-muted">Amount / month</span>
                    </td>

                    <td>
                      <h5 className="fs-14 my-1 fw-normal">
                        {item?.postionType?.name || "Not Provided"}
                      </h5>
                      <span className="text-muted">Position Type</span>
                    </td>
                    <td>
                      <h5 className="fs-14 my-1 fw-normal">
                        {item?.paymentCategory?.name || "Not Provided"}
                      </h5>
                      <span className="text-muted">Payment Category</span>
                    </td>
                    <td>
                      <h5 className="fs-14 my-1 fw-normal">
                        {item?.agency?.name || "Not Provided"}
                      </h5>
                      <span className="text-muted">Agency</span>
                    </td>
                    <td>
                      <h5 className="fs-14 my-1 fw-normal">
                        {item?.startDate ? moment(item?.startDate).format("DD MMM YYYY") : "Not Provided"} - {item?.endDate ? moment(item?.endDate).format("DD MMM YYYY") : "Not Provided"}
                      </h5>
                      <span className="text-muted">Period</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="align-items-center mt-4 pt-2 justify-content-between row text-center text-sm-start">
            <div className="col-sm">
              <div className="text-muted">
                Showing <span className="fw-semibold">{data?.length || 0}</span>{" "}
                of <span className="fw-semibold">{data?.length || 0}</span>{" "}
                Results
              </div>
            </div>
            <div className="col-sm-auto mt-3 mt-sm-0">
              {/* <ul className="pagination pagination-separated pagination-sm mb-0 justify-content-center">
            <li className="page-item disabled">
              <Link to="#" className="page-link">
                ←
              </Link>
            </li>
            <li className="page-item">
              <Link to="#" className="page-link">
                1
              </Link>
            </li>
            <li className="page-item active">
              <Link to="#" className="page-link">
                2
              </Link>
            </li>
            <li className="page-item">
              <Link to="#" className="page-link">
                3
              </Link>
            </li>
            <li className="page-item">
              <Link to="#" className="page-link">
                →
              </Link>
            </li>
          </ul> */}
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Payments;
